import '.aj{flex-shrink:0;}.ssr-plugin'
import '.aa{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.au{height:100%;}.ssr-plugin'
import '.aw{border:none;}.ssr-plugin'
import '.c6{background-color:transparent;}.ssr-plugin'
import '.c7{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.bc{position:sticky;}.ssr-plugin'
import '.c8{top:4rem;}.ssr-plugin'
import '.c9{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.ca{padding-bottom:1rem;}.ssr-plugin'
import '.cb{margin-bottom:1rem;}.ssr-plugin'
import '.cc{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bd{top:0px;}.ssr-plugin'
import '.bu{left:0px;}.ssr-plugin'
import '.bv{right:0px;}.ssr-plugin'
import '.bw{bottom:0px;}.ssr-plugin'
import '.cd{z-index:9999;}.ssr-plugin'
import '.ce{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.bb{justify-content:flex-end;}.ssr-plugin'
import '.av{flex:1;}.ssr-plugin'
import '.c5{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="aj aa n au aw c6 c7"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e a8"
    >
      <div className="bc c8 c9 t ca cb cc d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bd bu bv bw cd t ce d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="aa d bb cc"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="av c5">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
